import { gql } from "apollo-boost";

export const CREATE_MANY_OFFERPRICE_WITH_OFFERPRICE_GROUP = gql`
mutation CreateManyofferpricesWithofferpriceGroup($data: ManyOfferPriceWithOfferPriceGroupInput) {
  createManyofferpricesWithofferpriceGroup(data: $data) {
    id
    totalPrice
    sumPriceBaht
    sumPriceUsd
    change
    currency
    amount
    receivedMoney
    sumPrice
    payment
    isPaymented
    code
    survivalId
    survivalNumber
  }
}
`







